// extracted by mini-css-extract-plugin
export default {"story-feed-items":"PinnedStoryFeedItems_story-feed-items__SlkyD"};